import React from 'react'
import { connect } from 'react-redux'
import { string, bool, element } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import { getPublishedApp } from '@/store/selectors'

const OpenTutorialButton = ({
  tutorialUrl,
  disabled,
  className,
  size,
  icon,
  fullWidth,
  kind,
}) => {
  const handleClick = (e) => {
    e.preventDefault()
    window.open(tutorialUrl, '_blank', 'noopener noreferrer')
  }

  return (
    <Button
      kind={kind || 'primary'}
      icon={icon || ''}
      size={size}
      className={className}
      disabled={disabled}
      onClick={handleClick}
      fullWidth={fullWidth}
    >
      Tutorial
    </Button>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const { tutorialUrl } = getPublishedApp(state, id)

  return {
    tutorialUrl,
  }
}

OpenTutorialButton.propTypes = {
  tutorialUrl: string,
  disabled: bool,
  className: string,
  size: string,
  icon: element,
  fullWidth: bool,
  kind: string,
}

export default connect(mapStateToProps)(OpenTutorialButton)
